import { RegisterFormVariants } from '../../../components/pages/authentication/RegisterScreen/LaunchingRegisterForm/LaunchingRegisterForm.types';
import { ContactFormSchema } from '../../../components/pages/commons/Contact/Contact.types';
import {
  StaticGetEndpoints,
  StaticPostEndpoints,
} from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';

export const FORM_ENDPOINTS = Object.freeze({
  title: (variant: RegisterFormVariants) => api.get(StaticGetEndpoints.Title, { variant }),

  sendMessageCOntact: (data: ContactFormSchema) =>
    api.post(StaticPostEndpoints.SendContactMessage, data),
});
